const C = {
  name: "Sharing",
  dimensions: { width: 40, height: 40 },
  content: `
    <g fill="currentColor" stroke="none">
      <path d="M20 0C31.0423 0 40 8.95772 40 20H38C38 10.0623 29.9377 2 20 2C10.0623 2 2 10.0623 2 20C2 29.9377 10.0623 38 20 38V40C8.95772 40 0 31.0423 0 20C0 8.95772 8.95772 0 20 0Z" fill="currentColor"/>
      <path d="M20 6C27.7323 6 34 12.2677 34 20C34 27.7323 27.7323 34 20 34C12.2677 34 6 27.7323 6 20H8C8 26.6277 13.3723 32 20 32C26.6277 32 32 26.6277 32 20C32 13.3723 26.6277 8 20 8V6Z" fill="currentColor"/>
      <path d="M20 12C24.4183 12 28 15.5817 28 20C28 24.4183 24.4183 28 20 28C15.5817 28 12 24.4183 12 20C12 15.5817 15.5817 12 20 12ZM20 14C16.6863 14 14 16.6863 14 20C14 23.3137 16.6863 26 20 26C23.3137 26 26 23.3137 26 20C26 16.6863 23.3137 14 20 14Z" fill="currentColor"/>
    </g>
  `
};
export {
  C as Sharing
};
